// HomePage.js
import React from "react";
import SlideHome from "../../components/slideHome";
import Newsletter from "../../components/newsletter";
import Testimonials from "../../components/temoignages";
import FAQ from "../../components/questions";
import ActualitesHome from "../../components/actualitesHome";
import PourquoiDon from "../../components/pourquoiDon";
import ApropoHome from "../../components/aPropaHome";
import StickyButton from "../../components/StickyButton";

const HomePage = () => {
  return (
    <div>
      <SlideHome />

      <ApropoHome />

      <PourquoiDon />
      <ActualitesHome />
      <FAQ />
      <Testimonials />
      <Newsletter />
    </div>
  );
};

export default HomePage;
